import { Pipe, PipeTransform } from "@angular/core";

import { IdentificationTypeCodeMap } from "../Utils/identification-types-map";

@Pipe({
  name: "fullIdentification",
})
export class FullIdentificationPipe implements PipeTransform {
  public transform(value: string): string {
    const [identificationType, identificationNumber] = value.split("-");
    const mappedIdentificationType = IdentificationTypeCodeMap[identificationType] || identificationType;
    return `${mappedIdentificationType}-${identificationNumber}`;
  }
}
